var font = {
    "0": "M240 -240v1708q0 70 66.5 120t160.5 50h627q94 0 160.5 -50t66.5 -120v-1708q0 -70 -66.5 -120t-160.5 -50h-627q-94 0 -160.5 50.5t-66.5 119.5zM582 -182h397v1593h-397v-1593z",
    "1": "M211 1411v227h313q94 0 161 -50t67 -120v-1878h-342v1821h-199z",
    "2": "M238 -135l739 1143v403h-397v-405h-342v462q0 70 66.5 120t160.5 50h627q94 0 160.5 -50t66.5 -120v-477q0 -35 -14.5 -81t-32.5 -74l-658 -1018h705v-228h-1081v275z",
    "3": "M240 209h342v-391h397v719h-397l137 227h260v647h-397v-405h-342v462q0 70 66.5 120t160.5 50h627q94 0 160.5 -50t66.5 -120v-534q0 -70 -66.5 -120t-160.5 -50q94 0 160.5 -50t66.5 -122v-832q0 -70 -66.5 -120t-160.5 -50h-627q-94 0 -160.5 50.5t-66.5 119.5v449z ",
    "4": "M137 94v228l565 1316h517v-1316h227l-139 -228h-88v-504h-342v504h-740zM508 322h369v856z",
    "5": "M233 209h342v-391h398v907h-740l43 913h1039l-139 -227h-568l-22 -459h501q94 0 161 -50t67 -120v-1022q0 -70 -66.5 -120t-161.5 -50h-626q-94 0 -161 50.5t-67 119.5v449z",
    "6": "M240 -240v1708q0 70 66.5 120t160.5 50h627q94 0 160.5 -50t66.5 -120v-362h-342v305h-397v-647h512q94 0 160.5 -50t66.5 -122v-832q0 -70 -66.5 -120t-160.5 -50h-627q-94 0 -160.5 50.5t-66.5 119.5zM582 -182h397v719h-397v-719z",
    "7": "M223 1184v454h1082v-276l-523 -1772h-356l537 1821h-398v-227h-342z",
    "8": "M240 -240v832q0 72 66.5 122t160.5 50q-94 0 -160.5 50t-66.5 120v534q0 70 66.5 120t160.5 50h627q94 0 160.5 -50t66.5 -120v-534q0 -70 -66.5 -120t-160.5 -50q94 0 160.5 -50t66.5 -122v-832q0 -70 -66.5 -120t-160.5 -50h-627q-94 0 -160.5 50.5t-66.5 119.5z M582 -182h397v719h-397v-719zM582 764h397v647h-397v-647z",
    "9": "M240 123h342v-305h397v647h-512q-94 0 -160.5 50t-66.5 122v831q0 70 66.5 120t160.5 50h627q94 0 160.5 -50t66.5 -120v-1708q0 -70 -66.5 -120t-160.5 -50h-627q-94 0 -160.5 50.5t-66.5 119.5v363zM582 692h397v719h-397v-719z",
    "A": "M145 -410l478 2048h235l477 -2048h-254l-114 484h-453l-113 -484h-256zM565 295h350l-174 752z",
    "B": "M244 -410v2048h540q223 0 381 -146t158 -353v-101q0 -115 -53 -216t-148 -171q94 -72 147.5 -173t53.5 -216v-172q0 -207 -157.5 -353.5t-381.5 -146.5h-540zM520 -188h264q109 0 186 71.5t77 171.5v242q0 100 -77 172t-186 72h-264v-729zM520 762h264q109 0 186 71 t77 171v170q0 100 -77 171.5t-186 71.5h-264v-655z",
    "C": "M217 78v1073q0 201 143.5 344t345 143t345 -143t143.5 -344h-252v33q0 98 -69.5 167.5t-168 69.5t-168 -69.5t-69.5 -167.5v-1139q0 -98 69.5 -168t168 -70t168 70t69.5 168v33h252q0 -201 -143.5 -344.5t-345 -143.5t-345 143.5t-143.5 344.5z",
    "D": "M244 -410v2048h499q207 0 352.5 -146t145.5 -353v-1049q0 -207 -145.5 -353.5t-352.5 -146.5h-499zM500 -188h243q100 0 172 71.5t72 171.5v1119q0 100 -71.5 171.5t-172.5 71.5h-243v-1605z",
    "E": "M244 -410v2048h790v-221h-534v-692h487v-221h-487v-692h534v-222h-790z",
    "F": "M244 -410v2048h790v-221h-534v-692h487v-221h-487v-914h-256z",
    "G": "M217 78v1073q0 201 143.5 344t345 143t345 -143t143.5 -344h-252v33q0 98 -69.5 167.5t-168 69.5t-168 -69.5t-69.5 -167.5v-1139q0 -98 69.5 -168t168 -70t168 70t69.5 168v461h-237v217h489v-645q0 -201 -143.5 -344.5t-345 -143.5t-345 143.5t-143.5 344.5z",
    "H": "M244 -410v2048h256v-913h487v913h254v-2048h-254v914h-487v-914h-256z",
    "I": "M244 -410v2048h256v-2048h-256z",
    "J": "M129 -258l168 158q74 -90 188 -90q98 0 169 70.5t71 168.5v1589h254v-1554q0 -205 -144.5 -349.5t-349.5 -144.5q-211 0 -356 152z",
    "K": "M244 -410v2048h256v-933l456 933h287l-418 -850l473 -1198h-274l-350 887l-174 -354v-533h-256z",
    "L": "M244 -410v2048h256v-1826h534v-222h-790z",
    "M": "M244 -410v2048h233l412 -1134l414 1134h233v-2048h-256v1356l-311 -856h-158l-311 856v-1356h-256z",
    "N": "M244 -410v2048h229l514 -1364v1364h254v-2048h-229l-512 1364v-1364h-256z",
    "O": "M217 78v1073q0 201 143.5 344t345 143t345 -143t143.5 -344v-1073q0 -201 -143.5 -344.5t-345 -143.5t-345 143.5t-143.5 344.5zM467 45q0 -98 69.5 -168t168 -70t168 70t69.5 168v1139q0 98 -69.5 167.5t-168 69.5t-168 -69.5t-69.5 -167.5v-1139z",
    "P": "M244 -410v2048h540q223 0 381 -146t158 -353v-199q0 -205 -157.5 -351.5t-381.5 -146.5h-264v-852h-276zM520 664h264q109 0 186 70.5t77 172.5v267q0 100 -77 171.5t-186 71.5h-264v-753z",
    "Q": "M217 78v1071q0 203 143.5 346t345 143t345 -143t143.5 -346v-1071q0 -145 -78 -266l154 -129l-117 -140l-162 138q-127 -92 -284 -93q-203 0 -346.5 143.5t-143.5 346.5zM467 43q0 -98 69.5 -168t170.5 -70q55 0 104 25l-133 115l115 137l137 -117q14 39 14 78v1141 q0 98 -69.5 167.5t-169 69.5t-169 -69.5t-69.5 -167.5v-1141z",
    "R": "M244 -410v2048h499q207 0 353.5 -146t146.5 -353v-197q0 -154 -84 -277.5t-219 -181.5l303 -893h-270l-289 852h-184v-852h-256zM500 664h243q100 0 172 70.5t72 172.5h-2v267q0 100 -70.5 171.5t-171.5 71.5h-243v-753z",
    "S": "M217 78v43h250v-76q0 -98 69.5 -168t168 -70t169 70t70.5 168v248q0 49 -32.5 97t-77.5 67l-392 161q-92 39 -158.5 130.5t-66.5 183.5v219q0 201 143.5 344t345 143t345 -143t143.5 -344v-43h-252v76q0 98 -69.5 167.5t-168 69.5t-168 -69.5t-69.5 -167.5v-187 q0 -49 32.5 -97t78.5 -66l389 -162q94 -37 160.5 -136.5t66.5 -199.5v-258q0 -201 -143.5 -344.5t-345 -143.5t-345 143.5t-143.5 344.5z",
    "T": "M199 1417v221h997v-221h-371v-1827h-256v1827h-370z",
    "U": "M236 84v1554h253v-1589q0 -98 70 -168.5t170 -70.5t170 70.5t70 168.5v1589h254v-1554q0 -205 -144.5 -349.5t-349.5 -144.5t-349 144.5t-144 349.5z",
    "V": "M186 1638h263l307 -1421l307 1421h262l-442 -2048h-254z",
    "W": "M195 1638h260l227 -1323l254 1323h369l254 -1323l229 1323h260l-354 -2048h-256l-318 1649l-315 -1649h-256z",
    "X": "M213 -410l371 1024l-371 1024h256l244 -671l241 671h258l-372 -1024l372 -1024h-258l-241 672l-244 -672h-256z",
    "Y": "M180 1638h269l235 -766l238 766h268l-377 -1218v-830h-256v830z",
    "Z": "M233 -188l558 1605h-558v221h791v-221l-557 -1605h557v-222h-791v222z"
};
// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font_size = 18,
homeStringChange = 'Referee',
awayStringChange = 'Linesman',
referee = true,
panel_Hor_Adjustment = -1,
font_Top_Adjustment = -10,
tracking = 4,
small_Caps_Adjustment = {
    vertical: 0,
    horizontal: 0,
    scale_width: 0,
    scale_height: 0,
},
colors = {
    characters: {
        referee: [
            "#FFFFFF", // white
            "#231F20", // black
        ],
        linesman: [
            "#FFFFFF", // white
            "#231F20", // black
        ]
    },
    numbers: {
        referee: [
            "#FFFFFF", // white
            "#231F20", // black
        ],
        linesman: [
            "#FFFFFF", // white
            "#231F20", // black
        ]
    }
},
outlines = {
    characters: {
        width: 1.7
    },
    numbers: {
        width: 2.5
    }
},
special_Character_Adjustments = {
    period: {
        vertical: -1.5,
        horizontal: -2,
        scale_width: 15.5,
        scale_height: 15.5,
    },
    hyphen: {
        vertical: -8,
        horizontal: -5.5,
        scale_width: 0,
        scale_height: -3,
    },
    apostrophe: {
        vertical: -0.75,
        horizontal: -1,
        scale_width: 0,
        scale_height: 0,
    }
},
number_Adjustments = {
    top: -60,
    left: -9.5,
    width: 50,
    height: 35,
    middle_Space: 5,
    oneOffset: 7,
    singleDigitSpread: 1.2,
};